<template>
  <div>
    <h1 class="text-3xl mb-4">Updates</h1>
    <!-- TODO - MAKE THIS BETTER -->
    <div>
      <div
        class="p-3 text-left border-t"
        v-for="update in updates"
        :key="update.id"
      >
        <span class="text-gray-700 font-bold text-sm">{{ update.id }}</span>
        <br />
        <p class="mt-2">
          <span class="text-gray-700 font-bold">Goal:</span> {{ update.goal }}
        </p>
        <p class="mt-2">
          <span class="text-gray-700 font-bold">Summary:</span>
          <!-- TODO - DEAL WITH NO SUMMARY -->
          <!-- TODO - SHOW SOME KIND OF STREAK/ANALYTICS -->
          {{ update.summary }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UpdateView",
  computed: mapState({
    updates: (state) => state.updates.historical.reverse(),
  }),
  created() {
    this.$store.dispatch("updates/loadHistorical");
  },
};
</script>
